import { render, staticRenderFns } from "./SetLoginPassword.vue?vue&type=template&id=6fc9b9e1&scoped=true&"
import script from "./SetLoginPassword.vue?vue&type=script&lang=js&"
export * from "./SetLoginPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetLoginPassword.vue?vue&type=style&index=0&id=6fc9b9e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9b9e1",
  null
  
)

export default component.exports